(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["golf-art-personalization"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-golf-art-fields]').forEach((fields) => {
  const photo = fields.querySelector('[data-art-photo]');
  const error = fields.querySelector('[data-art-photo-error]');
  const validate = () => {
    const file = photo.files[0];
    let message = '';
    if (file && !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) message = photo.dataset.errorType;
    if (file && file.size > 20 * 1024 * 1024) message = photo.dataset.errorSize;
    photo.setCustomValidity(message);
    photo.setAttribute('aria-invalid', String(Boolean(message)));
    error.textContent = message;
    error.hidden = !message;
  };
  photo.addEventListener('change', validate);
  fields.closest('form').addEventListener('submit', (event) => {
    validate();
    if (!photo.checkValidity()) {
      event.preventDefault();
      photo.reportValidity();
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
